(() => {
  const policyBody = document.querySelector('.shopify-policy__body');
  if (!policyBody) return;

  policyBody.querySelectorAll('style').forEach((styleElement) => {
    styleElement.media = 'not all';
    styleElement.dataset.hmPolicyStyleReset = 'true';
  });

  const richText = policyBody.querySelector('.rte');
  const leadingText = richText?.firstChild;
  if (!leadingText || leadingText.nodeType !== Node.TEXT_NODE) return;

  const text = leadingText.nodeValue || '';
  const isVisibleLegacyStyle =
    /^\s*@import url\('https:\/\/fonts\.googleapis\.com\//.test(text) &&
    text.includes('--hm-green:') &&
    richText.children.length > 0;

  if (isVisibleLegacyStyle) leadingText.remove();
})();
